import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { TestimonialProps } from "../types/testimonials";

export const useBandTestimonials = (): TestimonialProps[] => {
    const { t } = useTranslation("bandTestimonials");

    // Get testimonials from current language
    const testimonials = t("testimonials", { returnObjects: true }) as Array<{
        quote: string;
        name: string;
        role: string;
    }>;

    // Safety check
    if (!Array.isArray(testimonials)) {
        return bandTestimonials;
    }

    // Map to TestimonialProps format
    return testimonials.map((item, index) => ({
        quote: item.quote,
        name: item.name,
        role: item.role,
        avatar: `/public/media/landing/avatar${index + 5}.png`,
        rating: index === 2 || index === 5 ? 4 : 5,
        index,
    }));
};

// Export static data for backward compatibility (optional)
export const bandTestimonials: TestimonialProps[] = [
    {
        quote: "مچ‌بند دلبند، ردیابی خواب من را متحول کرده است. حالا با داده‌های دقیق، کیفیت خوابم را بهبود بخشیده‌ام.",
        name: "سارا احمدی",
        role: "بهبود خواب",
        avatar: "/public/media/landing/avatar5.png",
        rating: 5,
        index: 0,
    },
    {
        quote: "پایش اکسیژن خون و ضربان قلب در طول تمرینات، به من کمک می‌کند تا عملکردم را بهینه کنم و از سلامت قلبم مطمئن باشم.",
        name: "علی کریمی",
        role: "دونده ماراتن",
        avatar: "/public/media/landing/avatar6.png",
        rating: 5,
        index: 1,
    },
    {
        quote: "قابلیت ECG این مچ‌بند، آرامش خاطر بی‌نظیری به من می‌دهد. می‌توانم در هر زمان نوار قلبم را بررسی کنم.",
        name: "رضا حسینی",
        role: "بیمار قلبی بهبود یافته",
        avatar: "/public/media/landing/avatar7.png",
        rating: 4,
        index: 2,
    },
    {
        quote: "HRV و پایش استرس، به من کمک می‌کند تا سطح استرسم را مدیریت کنم و از فرسودگی شغلی جلوگیری کنم.",
        name: "مریم قاسمی",
        role: "کارآفرین موفق",
        avatar: "/public/media/landing/avatar8.png",
        rating: 5,
        index: 3,
    },
    {
        quote: "برای سلامت بانوان، این مچ‌بند یک ابزار ضروری است. ردیابی چرخه قاعدگی و علائم، بسیار دقیق و کاربردی است.",
        name: "زهرا نادری",
        role: "پزشک متخصص زنان",
        avatar: "/public/media/landing/avatar9.png",
        rating: 5,
        index: 4,
    },
    {
        quote: "قدم‌شمار و مودهای ورزشی متنوع، انگیزه من را برای فعالیت بیشتر افزایش داده است. حالا هر روز اهداف جدیدی دارم.",
        name: "محسن رضایی",
        role: "علاقه‌مند به تناسب اندام",
        avatar: "/public/media/landing/avatar10.png",
        rating: 4,
        index: 5,
    },
    {
        quote: "تشخیص افتادن و اعلان‌های هوشمند، امنیت من را در خانه تضمین می‌کند. یک ابزار عالی برای سالمندان.",
        name: "خانم شریفی",
        role: "بازنشسته فعال",
        avatar: "/public/media/landing/avatar11.png",
        rating: 5,
        index: 6,
    },
];
